export const MINIMUM_PASSWORD_LENGTH = 12;

export const passwordChecks = [
  { desc: "Une ou plusieurs lettres minuscules", errorType: "lowercase" },
  { desc: "Une ou plusieurs lettres majuscules", errorType: "uppercase" },
  { desc: "Un ou plusieurs chiffres", errorType: "number" },
  { desc: "Un ou plusieurs caractères spéciaux", errorType: "special" },
  {
    desc: `${MINIMUM_PASSWORD_LENGTH} caractères minimum`,
    errorType: "length",
  },
];

export const getPasswordMessage = (value: string) => {
  const message = [];
  if (value.length < MINIMUM_PASSWORD_LENGTH) message.push("length");
  if (!/[a-z]/.test(value)) message.push("lowercase");
  if (!/[A-Z]/.test(value)) message.push("uppercase");
  if (!/[0-9]/.test(value)) message.push("number");
  if (!/[ !"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~]/.test(value))
    message.push("special");
  return message.join(", ");
};
